import { render } from "./DashboardPredictiveAnalyticsContributions.vue?vue&type=template&id=386f8945"
import script from "./DashboardPredictiveAnalyticsContributions.vue?vue&type=script&lang=js"
export * from "./DashboardPredictiveAnalyticsContributions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__